export type OwnershipValidationResult = {
  errorProfileIds: Set<string>;
  message: string;
};

export type OwnershipViolation = {
  parent_profile_id: number;
  profile_ids: number[];
};

export type GraphQLErrorLike = {
  message: string;
  extensions?: {
    violations?: OwnershipViolation[];
  };
};

export const OWNERSHIP_MIN = 0;
export const OWNERSHIP_MAX = 100;

export const parseOwnershipToNumber = (value: string | null | undefined): number | null => {
  if (value == null || value === "" || value === "--") return null;
  const match = String(value)
    .trim()
    .replace(/%$/, "")
    .match(/^\d+(\.\d+)?$/);
  if (!match) return null;
  const n = parseFloat(match[0]);
  return Number.isFinite(n) ? n : null;
};

export const isOwnerRole = (relationship: string | null | undefined): boolean => {
  if (!relationship) return false;
  return relationship.toLowerCase().includes("owner");
};

const profileIdsFromViolations = (
  violations: OwnershipViolation[] | undefined,
): Set<string> => {
  const ids = new Set<string>();
  if (!Array.isArray(violations)) return ids;
  for (const v of violations) {
    if (Array.isArray(v.profile_ids)) {
      for (const id of v.profile_ids) {
        ids.add(String(id));
      }
    }
  }
  return ids;
};

export const getFirstGraphQLError = (raw: unknown): GraphQLErrorLike | null => {
  if (!raw || typeof raw !== "object") return null;
  const err = raw as {
    graphQLErrors?: GraphQLErrorLike[];
    message?: string;
    extensions?: unknown;
  };
  const first = err.graphQLErrors?.[0];
  if (first?.message) return first;
  if (typeof err.message === "string") {
    return {
      message: err.message,
      extensions: err.extensions as GraphQLErrorLike["extensions"],
    };
  }
  return null;
};

export const buildOwnershipValidationFromError = (
  error: GraphQLErrorLike | null | undefined,
): OwnershipValidationResult | null => {
  if (!error?.message) return null;
  const violations = error.extensions?.violations;
  const profileIds = profileIdsFromViolations(violations);
  return {
    errorProfileIds: profileIds,
    message: error.message,
  };
};
